<template>
    <div>
        <Main title="My Audiences" subtitle="Private Audiences">
            <template v-slot:buttons>
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Create">
                    <a @click="createNewActivation()" class="btn btn-success ml-1 text-white" data-toggle="tooltip" title="Create New Audience"><i class="fas fa-plus-circle"></i> Create</a>
                </div><!--btn-toolbar-->
            </template>

            <template v-slot:table>
                <v-app>
                    <div class="row">
                        <div class="col-md-4 col-8">
                            <div class="input-group">
                                <v-text-field
                                    v-model="searchData.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by audience name or ID"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="offset-md-7 offset-3 col-1">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Filter Audiences</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.itemsPerPage"
                                                :items="perPage"
                                                label="Per Page"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="searchData.createdBy"
                                                :items="$store.getters['getCreatedByItems']"
                                                label="Created By"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="searchData.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>
                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="! is_activation_allowed" class="alert alert-warning" role="alert">
                        Activation is not allowed due to NOT completed AKG Contracts Signing Process!
                    </div>

                    <TableLoading cols="10" v-if="loading"></TableLoading>

                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Audience Identifier</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Audience Name</span>
                                        </template>
                                        <span>Audience Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Analyses</span>
                                        </template>
                                        <span>Audience Analyses (Audience, Cross Visitation, Cross Apps, Frequency)</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Data Set</span>
                                        </template>
                                        <span>Data Set</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Status</span>
                                        </template>
                                        <span>Status</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Analytics</span>
                                        </template>
                                        <span>Audience Analytics (Total visits, Unique EIDs, Average Visits, Average Uniques)</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Issued by</span>
                                        </template>
                                        <span>Audience issued by</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated at</span>
                                        </template>
                                        <span>Updated at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created at</span>
                                        </template>
                                        <span>Created at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Actions</span>
                                        </template>
                                        <span>Actions</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <TableLoading v-if="loading"></TableLoading>
                            <tr v-for="audience in audiences" :key="audience.id" class="activation-row" v-if="audiences">
                                <td>{{ audience.id || '' }}</td>
                                <td>
                                    <v-tooltip
                                        top
                                        color="primary"
                                        v-if="audience.scheduler"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">
                                                <i class="fas fa-sync-alt mr-1 text-info"></i>
                                            </span>
                                        </template>
                                        <span>Created by Scheduler</span>
                                    </v-tooltip>
                                    {{ audience.name || '' }}
                                </td>
                                <td>
                                    <ul class="list-no-bullets-no-padding-left">
                                        <li v-if="audience.dataset && audience.dataset[0] && audience.dataset[0].analysistype !== 'Anonymized'">Audience</li>
                                        <li v-for="analysis in audience.analyses" v-if="audience.analyses && analysis.process">
                                            <span v-if="analysis.name == 'Frequency' && analysis.day_part">Day Part </span>
                                            <span v-if="analysis.name == 'Frequency' && !analysis.day_part">Daily </span>
                                            {{ analysis.name || '' }}
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <ul class="list-no-bullets-no-padding-left" v-for="(activationItem, index) in audience.dataset" :key="index" v-if="audience.dataset">
                                        <li>Analysis Type: <strong>{{ activationItem.analysistype || '' }}</strong></li>
                                        <li v-if="activationItem.startDate">Start Date: <strong>{{ activationItem.startDate || '' }}</strong></li>
                                        <li v-if="activationItem.endDate">End Date: <strong>{{ activationItem.endDate || '' }}</strong></li>
                                    </ul>
                                </td>
                                <td>
                                    <v-progress-linear
                                        v-if="!audience.isCompleted && !audience.status.isError && (![106, 107].includes(audience.status.code))"
                                        color="#fb7e42"
                                        height="10"
                                        indeterminate
                                        rounded
                                    ></v-progress-linear>

                                    <v-progress-linear
                                        v-if="audience.isCompleted"
                                        color="success"
                                        height="10"
                                        value="100"
                                        rounded
                                    ></v-progress-linear>

                                    <v-progress-linear
                                        v-if="audience.status.code === 107"
                                        color="info"
                                        height="10"
                                        value="100"
                                        rounded
                                    ></v-progress-linear>

                                    <span :class="!audience.status.isError || 'text-danger'">
                                        {{ audience.status.string }}

                                        <v-tooltip top v-if="!audience.isCompleted && audience.status.message" :color="audience.status.isError ? 'error' : 'info'">
                                            <template v-slot:activator="{ on, attrs }">
                                                <i v-bind="attrs" v-on="on" class="fas fa-info-circle" :class="audience.status.isError ? 'text-danger' : 'text-info'"></i>
                                            </template>
                                            <span>
                                                {{ audience.status.message }}
                                            </span>
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td>
                                    <ul style="list-style: none;" v-if="audience.isCompleted || audience.status.code === 106">
                                        <li v-for="item in audience.totals">
                                            <v-tooltip left>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on"> {{ item.label }}: {{ new Intl.NumberFormat().format(item.count) }} </span>
                                                </template>
                                                <span>
                                                {{ item.desc }}
                                                </span>
                                            </v-tooltip>
                                        </li>
                                    </ul>
                                </td>
                                <td>{{ audience.user_id || '' }}</td>
                                <td>{{ audience.updated_at || '' }}</td>
                                <td>{{ audience.created_at || '' }}</td>
                                <td class="btn-td">
                                    <div class="btn-group" role="group" aria-label="userActions">

                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showAudience(audience)"
                                                    class="btn btn-info">
                                                    <i class="fas fa-eye"></i>
                                                </button>
                                            </template>
                                            <span>View More Details</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary" v-if="audience.isCompleted && audience.resultsCount && audience.isActivationAllowed && is_activation_allowed">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="activateAudience(audience)"
                                                    class="btn btn-success">
                                                    <i class="fas fa-check"></i>
                                                </button>
                                            </template>
                                            <span>Activate your custom audience</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary" v-else-if="audience.isCompleted && !audience.isActivationAllowed && is_activation_allowed">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    disabled
                                                    class="btn btn-dark">
                                                    <i class="fas fa-check"></i>
                                                </button>
                                            </template>
                                            <span>Activating audience below {{ minimum_audience_to_activate }} devices is not allowed</span>
                                        </v-tooltip>

                                        <button
                                            v-else
                                            disabled
                                            class="btn btn-dark">
                                            <i class="fas fa-check"></i>
                                        </button>

                                        <div class="btn-group btn-group-sm" role="group">
                                            <button id="userActions" type="button" class="btn btn-full-black dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                More
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="userActions">
                                                <a @click="cloneAudience(audience)" class="dropdown-item"><i class="fas fa-clone"></i> Duplicate</a>
                                                <a v-if="audience.isCompleted && audience.dataset[0].analysistype !== 'Anonymized' && $store.getters.getUserPermissions.includes('frontend-data-explorer-analyses-cohorts')" @click="createCohort(audience)" class="dropdown-item"><i class="fas fa-layer-group"></i> Create Cohort</a>
                                                <a v-if="audience.isCompleted && !audience.scheduler && $store.getters.getUserPermissions.includes('frontend-data-explorer-analyses-scheduler')" @click="scheduleAudience(audience)" class="dropdown-item"><i class="fas fa-redo"></i> Create Scheduler</a>
                                                <a @click="showDeleteModal(audience)" class="dropdown-item"><i class="fas fa-trash-alt"></i> Delete</a>
                                            </div>
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <v-pagination
                        color="#ff7516"
                        v-if="totalPages > 1"
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="7"
                    ></v-pagination>

                    </div>
                </v-app>
            </template>
        </Main>
        <CreateNewPrivateAudience v-if="$store.getters['CreateAudienceStore/getModalStatus']"></CreateNewPrivateAudience>
        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
        <ShowAudienceItem v-if="showAudienceItem"></ShowAudienceItem>
        <ActivateAudienceItem v-if="$store.getters['ActivateAudienceStore/getModalStatus']"></ActivateAudienceItem>
        <CreateNewScheduler v-if="$store.getters['CreateAudienceStore/getSchedulerModalStatus']" :data-object="schedulingData"></CreateNewScheduler>
<!--        <CohortsManagement v-if="showCohortsDialog"></CohortsManagement>-->
        <CreateNewCohortByFile v-if="showNewCohortDialog" :audience="cohortAudience"></CreateNewCohortByFile>
        <CohortActions v-if="showCohortActionsDialog"></CohortActions>
    </div>
</template>

<script>
import Main from '../../components/Main'
import api from "../../api/analyses/activations";
import CreateNewPrivateAudience from "../../components/analyses/CreateNewPrivateAudience";
import DeleteModal from "../../components/general/DeleteModal";
import ShowAudienceItem from "../../components/analyses/ShowAudienceItem";
import ActivateAudienceItem from "../../components/analyses/ActivateAudienceItem";
import mixins from "../../mixin"
import TableLoading from "../../components/general/TableLoading";
import CreateNewScheduler from "../../components/analyses/CreateNewScheduler";
//import CohortsManagement from "../../components/analyses/CohortsManagementLegacy.vue";
import CreateNewCohortByFile from "../../components/analyses/CreateNewCohortByFile.vue";
import CohortActions from "../../components/analyses/CohortActions.vue";

export default {
    name: "MyAudiences",
    mixins: [mixins],
    data: () => ({
        filter: false,
        currentPage: 1,
        totalPages: 1,

        searchData: {
            q: '',
            sortBy: 'created_at',
            orderBy: 'desc',
            itemsPerPage: 25,
            createdBy: 'company',
            loading: false,
        },

        schedulingData: {
            name: '',
            id: ''
        },

        sorts: [
            {
                value: 'name',
                text: 'Name'
            },
            {
                value: 'status',
                text: 'Status'
            },
            {
                value: 'resultsCount',
                text: 'Results Count'
            },
            {
                value: 'created_at',
                text: 'Last Created'
            },
            {
                value: 'updated_at',
                text: 'Last Updated'
            },
        ],

        is_activation_allowed: true,
        loading: true,
        deleteModalDialog: false,
        showCloneDialog: false,
        audiences: [],
        showAudienceItem: false,
        showingAudience: '',
        deletingAudience: [],
        cloningAudience: '',
        activatingAudience: '',
        showActivateItem: false,
        showScheduleDialog: false,
        showCohortsDialog: false,
        showNewCohortDialog: false,
        showCohortActionsDialog: false,

        cohortAudience: [],
    }),
    components: {
        CohortActions,
        CreateNewCohortByFile,
        CreateNewScheduler,
        TableLoading,
        Main,
        CreateNewPrivateAudience,
        DeleteModal,
        ShowAudienceItem,
        ActivateAudienceItem
    },
    methods: {
        async fetchData() {
            await api.getAllAudiences({
                page: this.currentPage,
                total: this.searchData.itemsPerPage,
                q: this.searchData.q,
                sortBy: this.searchData.sortBy,
                orderBy: this.searchData.orderBy,
                createdBy: this.searchData.createdBy
            })
            .then(res => {
                this.audiences = res.data.data
                this.currentPage = res.data.pagination.current_page
                this.totalPages = res.data.pagination.last_page
                this.is_activation_allowed = res.data.is_activation_allowed
                this.loading = false
                this.scrollToTop()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        createNewActivation() {
            this.$store.commit('CreateAudienceStore/SET_MODAL', true)
        },
        showDeleteModal(audience) {
            this.deletingAudience = audience
            this.deleteModalDialog = true
        },
        cloneAudience(audience) {
            this.$store.commit('CreateAudienceStore/SET_MODAL', true)
            this.$store.dispatch('CreateAudienceStore/fetchCloningAudience', audience.id)
        },
        // showCohortsManagementModal() {
        //     this.showCohortsDialog = true
        //     if ((window.location !== window.location + '/cohorts/') && (window.location.href.split('/').slice(-1)[0] !== 'cohorts')) {
        //         window.history.pushState({}, null, window.location + '/cohorts');
        //     }
        // },
        // showNewCohortModal() {
        //     this.showNewCohortDialog = true
        // },
        // showCohortActionsModal() {
        //     this.showCohortActionsDialog = true
        // },
        async createCohort(audience) {
            this.cohortAudience = audience
            this.showNewCohortDialog = true
            // await api.createNewCohort({
            //     audience: audience.id
            // })
            // .then(res => {
            //     this.$toast.open({
            //         message: res.data.message,
            //         type: "success",
            //     })
            // })
            // .catch(e => {
            //     this.$toast.open({
            //         message: e.response.data.message,
            //         type: "error",
            //     })
            // })
        },
        showAudience(audience) {
            this.showingAudience = audience.id
            this.showAudienceItem = true
            if ((window.location !== window.location + '/item/' + audience.id + '/show') && (window.location.href.split('/').slice(-1)[0] !== 'show')) {
                window.history.pushState({}, null, window.location + '/item/' + audience.id + '/show');
            }
        },
        scheduleAudience(audience) {
            this.schedulingData.id = audience.id
            this.schedulingData.name = audience.name

            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_MODAL', true)
        },
        activateAudience(audience) {
            this.$store.commit('ActivateAudienceStore/SET_AUDIENCE_ID', audience.id)
            this.$store.commit('ActivateAudienceStore/SET_MODAL', true)
        },
        async deleteItem() {
            await api.deleteAudience({
                audience: this.deletingAudience.id,
                _token: $('meta[name="_token"]').attr('content')
            })
            .then(res => {
                this.deleteModalDialog = false
                this.deletingAudience = []
                this.fetchData()
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.scrollToTop()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.deleteModalDialog = false
                this.deletingAudience = []
                this.scrollToTop()
            })
        },
        filterData: _.debounce(function() {
            this.fetchData()
            this.searchData.loading = false
        }, 800),
        fetchAudienceById: _.debounce(function (id) {
            this.showAudience({'id': id})
        }, 800),
    },
    created() {
        this.fetchData()
        let id = window.location.href.split('/').slice(-2)[0]
        let page = window.location.href.split('/').slice(-2)[1]
        if (!isNaN(id)) {
            this.fetchAudienceById(id)
        } else if (page === 'cohorts') {
            this.showCohortsDialog = true
        }
    },
    computed: {
        //
    },
    watch: {
        '$store.getters.getCompanyId' : function (val) {
            if (val !== null) {
                window.Echo.private('audiences-' + this.$store.getters.getCompanyId)
                    .listen('Backend\\Activation\\AudienceUpdated', (e) => {
                        this.fetchData()
                    })
                    .listen('Backend\\Activation\\AudienceCompleted', (e) => {
                        this.fetchData()
                    })
                    .listen('.audience-created', (e) => {
                        this.$store.commit('CreateAudienceStore/SET_MODAL', false)
                        this.$store.commit('CreateAudienceStore/RESET_STATE')
                        this.fetchData()
                    })
            }
        },
        currentPage: function () {
            this.fetchData()
        },
        'searchData.q': function () {
            if (this.searchData.q == null) {
                this.searchData.q = ""
            }
            this.filterData()
        },
        'searchData.sortBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.orderBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.itemsPerPage': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.createdBy': function () {
            this.searchData.loading = true
            this.filterData()
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
    min-height: fit-content;
}

button:focus {
    outline:0;
}

.btn-info {
    border-radius: 5px 0px 0px 5px;
}

</style>